// https://openlayers.org/en/latest/apidoc/

import './style.css';
import {Map, View} from 'ol';
import KML from 'ol/format/KML.js';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Layer from 'ol/layer/WebGLTile.js';
import Google from 'ol/source/Google.js';
import VectorLayer from 'ol/layer/Vector.js'
import VectorSource from 'ol/source/Vector.js';
import Style from 'ol/style/Style.js';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';
import {fromLonLat} from 'ol/proj';


// Styles for overlay vector layers.
var styleBoundary = new Style({stroke: new Stroke({color: [234, 50, 50, 0.70],  width: 4}), fill: new Fill({color: [100, 50, 200, 0.5]  })});
var styleAirport  = new Style({stroke: new Stroke({color: [192, 192, 64, 0.95], width: 2}), fill: new Fill({color: [32, 32, 32, 0.95]   })});
var styleWater    = new Style({stroke: new Stroke({color: [52, 128, 255, 0.95], width: 2}), fill: new Fill({color: [84, 233, 255, 0.95] })});
var styleOasi     = new Style({stroke: new Stroke({color: [212, 212, 0, 0.85],  width: 2}), fill: new Fill({color: [185, 255, 255, 0.85] })});
var stylePark     = new Style({stroke: new Stroke({color: [255, 255, 0, 0.50],  width: 2}), fill: new Fill({color: [130, 255, 120, 0.40] })});
var styleWaste    = new Style({stroke: new Stroke({color: [255, 255, 0, 0.95],  width: 2}), fill: new Fill({color: [230, 0, 0, 0.95] })});


// Base layers.
const source_osm = new OSM();
const source_google_roadmap = new Google({
    key: 'AIzaSyDj66LCm5nXQrzDL3-AqhNvDLiF-4hV9pM',
    mapType: 'roadmap',
    scale: 'scaleFactor2x',
    highDpi: true,
});
const source_google_satellite = new Google({
    key: 'AIzaSyDj66LCm5nXQrzDL3-AqhNvDLiF-4hV9pM',
    mapType: 'satellite',
    scale: 'scaleFactor2x',
    highDpi: true,
});
const basemaps = {
    google_roadmap: new Layer({source: source_google_roadmap}),
    google_satellite: new Layer({source: source_google_satellite}),
    osm: new TileLayer({source: source_osm})
}

// Overlay layers.
const overlays = {
    campi_bisenzio:          new VectorLayer({source: new VectorSource({url: 'share/campi_bisenzio.kml',              format: new KML({extractStyles: false})}), style: styleBoundary}),
    sesto_fiorentino:        new VectorLayer({source: new VectorSource({url: 'aeroporto/sesto_fiorentino.kml',        format: new KML({extractStyles: false})}), style: styleBoundary}),
    oasi:                    new VectorLayer({source: new VectorSource({url: 'aeroporto/oasi.kml',                    format: new KML({extractStyles: false})}), style: stylePark}),
    parco_piana:             new VectorLayer({source: new VectorSource({url: 'aeroporto/parco_piana.kml',             format: new KML({extractStyles: false})}), style: stylePark}),
    rifiuti:                 new VectorLayer({source: new VectorSource({url: 'aeroporto/rifiuti.kml',                 format: new KML({extractStyles: false})}), style: styleWaste}),
    fosso_reale_attuale:     new VectorLayer({source: new VectorSource({url: 'aeroporto/fosso_reale_attuale.kml',     format: new KML({extractStyles: false})}), style: styleWater}),
    fosso_reale_master_plan: new VectorLayer({source: new VectorSource({url: 'aeroporto/fosso_reale_master_plan.kml', format: new KML({extractStyles: false})}), style: styleWater}),
    amerigo_vespucci:        new VectorLayer({source: new VectorSource({url: 'aeroporto/peretola.kml',                format: new KML({extractStyles: false})}), style: styleAirport}),
    nuovo_aeroporto:         new VectorLayer({source: new VectorSource({url: 'aeroporto/nuovo_aeroporto.kml',         format: new KML({extractStyles: false})}), style: styleAirport}),
};

// Set default visibility for basemaps and enable EventListener for visibilty toggle.
document.querySelectorAll('input[name="basemap"]').forEach(radio => {
    const layer_name = radio.value;
    basemaps[layer_name].setVisible(radio.checked);
    radio.addEventListener('change', function() {
        const selectedLayer = this.value;
        basemaps['google_roadmap'].setVisible(selectedLayer === 'google_roadmap');
        basemaps['google_satellite'].setVisible(selectedLayer === 'google_satellite');
        basemaps['osm'].setVisible(selectedLayer === 'osm');
    });
});


// Set default visibility for overlays and enable EventListener for visibilty toggle.
document.querySelectorAll('input[name="overlay"]').forEach(checkbox => {
    const selectedLayer = checkbox.value;
    if (!checkbox.checked) {
        overlays[selectedLayer].setVisible(false);
    }
    checkbox.addEventListener('change', function() {
        const selectedLayer = this.value;
        overlays[selectedLayer].setVisible(this.checked);
    });
});


// Keyboard control for layer toggling.
function handleKeyDown(event) {
    var toggle_overlay = '';
    switch (event.code) {
        case 'KeyC': toggle_overlay = 'campi_bisenzio'; break;
        case 'KeyS': toggle_overlay = 'sesto_fiorentino'; break;
        case 'KeyP': toggle_overlay = 'parco_piana'; break;
        case 'KeyO': toggle_overlay = 'oasi'; break;
        case 'KeyI': toggle_overlay = 'rifiuti'; break;
        case 'KeyF': toggle_overlay = 'fosso_reale_attuale'; break;
        case 'KeyM': toggle_overlay = 'fosso_reale_master_plan'; break;
        case 'KeyA': toggle_overlay = 'amerigo_vespucci'; break;
        case 'KeyN': toggle_overlay = 'nuovo_aeroporto'; break;
    }
    if (toggle_overlay != '') {
        const checkbox = document.querySelector('input[type="checkbox"][name="overlay"][value="' + toggle_overlay + '"]');
        checkbox.click();
    }
}
document.addEventListener('keydown', handleKeyDown);


// Add the map, then add the overlays.
const map = new Map({
    target: 'map',
    layers: [basemaps['google_roadmap'], basemaps['google_satellite'], basemaps['osm']],
    view: new View({
      center: fromLonLat([11.19, 43.82], 'EPSG:3857'),
      zoom: 14
    })
});
for (const layer in overlays) {
    map.addLayer(overlays[layer]);
};

// TODO: Add keyboard control.
